import { ActionTree } from 'vuex';
import AppSettings from 'arc4u.framework.js/token/AppSettings';
import TokenKeys from 'arc4u.framework.js/token/TokenKeys';
import IAppSettings from 'arc4u.framework.js/token/IAppSettings';

import { RootState } from '@/types'
import { rootErrorsMutationBuilder, mutationTypes as errorsMutationTypes } from '@/store/module/errors/mutations';

import { ReferenceDataState } from './types'
import { createStoreModulePath } from '@/lib/store.utils';
import { InfraClient } from '@/proxy/Prequalification.CandidateMgt.FacadeClient';
import { mutationTypes } from './mutations';

export const rootReferenceDataActionBuilder = createStoreModulePath('referenceData');

export const actionTypes = {
  fetchAll: 'fetchAll',
  
  fetchCountries: 'fetchCountries',
  fetchLanguages: 'fetchLanguages',
  fetchCompetences: 'fetchCompetences',
  fetchRoles: 'fetchRoles',
  fetchTitles: 'fetchTitles',
  fetchLegalStatuses: 'fetchLegalStatuses',
} as const;

const getInfraProxy = () => {
  const settings: IAppSettings = AppSettings.Get("OAuth");

  return new InfraClient(
    settings.Values.filter(v => v.Key === TokenKeys.RootServiceUrlKey)[0].Value
  );
};

const setErrorMutationType = rootErrorsMutationBuilder(errorsMutationTypes.setError);

export const actions: ActionTree<ReferenceDataState, RootState> = {
  async [actionTypes.fetchAll]({ dispatch }) {
    dispatch(actionTypes.fetchCountries);
    dispatch(actionTypes.fetchLanguages);
    dispatch(actionTypes.fetchCompetences);
    dispatch(actionTypes.fetchRoles);
    dispatch(actionTypes.fetchTitles);
    dispatch(actionTypes.fetchLegalStatuses);
  },

  async [actionTypes.fetchCountries]({ state, commit }) {
    if (state.countries?.length) {
      return;
    }
    
    try {
      const countries = await getInfraProxy().getCountries();

      commit(mutationTypes.setCountries, countries);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
  async [actionTypes.fetchLanguages]({ state, commit }) {
    if (state.languages?.length) {
      return;
    }
    
    try {
      const languages = await getInfraProxy().getLanguages();
  
      commit(mutationTypes.setLanguages, languages);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
  async [actionTypes.fetchCompetences]({ state, commit }) {
    if (state.competences?.length) {
      return;
    }
    
    try {
      const competences = await getInfraProxy().getCompetences();
  
      commit(mutationTypes.setCompetences, competences);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
  async [actionTypes.fetchRoles]({ state, commit }) {
    if (state.roles?.length) {
      return;
    }
    
    try {
      const roles = await getInfraProxy().getRoles();
  
      commit(mutationTypes.setRoles, roles);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
  async [actionTypes.fetchTitles]({ state, commit }) {
    if (state.titles?.length) {
      return;
    }
    
    try {
      const titles = await getInfraProxy().getPersonTitles();
  
      commit(mutationTypes.setTitles, titles);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
  async [actionTypes.fetchLegalStatuses]({ state, commit }) {
    if (!state.countryId) {
      return;
    }
    
    try {
      const legalStatuses = await getInfraProxy().getLegalStatusByCountryId(state.countryId);
  
      commit(mutationTypes.setLegalStatuses, legalStatuses);
    } catch {
      commit(setErrorMutationType, null, { root: true });
    }
  },
}